import { render } from "./PreviewArticlePage.vue?vue&type=template&id=c68681d6"
import script from "./PreviewArticlePage.vue?vue&type=script&lang=js"
export * from "./PreviewArticlePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__